import script from "./windowsTaskbar.vue?vue&type=script&setup=true&lang=js"
export * from "./windowsTaskbar.vue?vue&type=script&setup=true&lang=js"

import "./windowsTaskbar.vue?vue&type=style&index=0&id=4b2ad664&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4b2ad664"]])

export default __exports__